import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import {
  eventoDashboardGuard,
  eventoFuncionesGuard,
  eventoGestionGuard,
  eventoHistorialCarritosGuard,
  eventoInfoBasicaGuard,
  eventoReportesGuard,
  eventoVentasGuard
} from './core/guards/evento-permissions.guard';
import { AppDashboardComponent } from './layout/app-dashboard/app-dashboard.component';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    component: AppDashboardComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('./home/home.page').then(m => m.HomePage)
      },
      {
        path: 'profile',
        loadComponent: () => import('./pages/profile/profile.page').then(m => m.ProfilePage)
      },
      {
        path: 'organizadores',
        loadComponent: () => import('./pages/organizador/index/index.page').then(m => m.IndexPage)
      },
      {
        path: 'organizador/create',
        loadComponent: () => import('./pages/organizador/create/create.page').then(m => m.CreatePage)
      },
      {
        path: 'organizador/:id',
        loadComponent: () => import('./pages/organizador/show/show.page').then(m => m.ShowPage)
      },
      {
        path: 'organizador/:id/edit',
        loadComponent: () => import('./pages/organizador/edit/edit.page').then(m => m.EditPage)
      },
      {
        path: 'eventos',
        loadComponent: () => import('./pages/eventos/index/index.page').then(m => m.IndexPage)
      },
      {
        path: 'eventos/create',
        loadComponent: () => import('./pages/eventos/create/create.page').then(m => m.CreatePage)
      },
      {
        path: 'eventos/:id',
        canActivate: [eventoDashboardGuard],
        loadComponent: () => import('./pages/eventos/dashboard/dashboard.page').then(m => m.DashboardPage)
      },
      {
        path: 'eventos/:id/edit',
        canActivate: [eventoInfoBasicaGuard],
        loadComponent: () => import('./pages/eventos/edit/edit.page').then(m => m.EditPage)
      },
      {
        path: 'eventos/:id/configuraciones',
        loadComponent: () => import('./pages/eventos/configuraciones/configuraciones.page').then(m => m.ConfiguracionesPage)
      },
      {
        path: 'eventos/:id/tipos-ticket',
        canActivate: [eventoGestionGuard],
        loadComponent: () => import('./pages/eventos/tipos-ticket/index/index.page').then(m => m.IndexPage)
      },
      {
        path: 'eventos/:id/tipos-ticket/:tipoticketid/edit',
        canActivate: [eventoGestionGuard],
        loadComponent: () => import('./pages/eventos/tipos-ticket/edit/edit.page').then(m => m.EditPage)
      },
      {
        path: 'eventos/:id/tipos-ticket/:tipoticketid/tickets',
        canActivate: [eventoGestionGuard],
        loadComponent: () => import('./pages/eventos/tipos-ticket/tickets/tickets.page').then(m => m.TicketsPage)
      },
      {
        path: 'eventos/:id/listas-tickets',
        canActivate: [eventoGestionGuard],
        loadComponent: () => import('./pages/eventos/listas-tickets/index/index.page').then(m => m.IndexPage)
      },
      {
        path: 'eventos/:id/listas-tickets/create',
        canActivate: [eventoGestionGuard],
        loadComponent: () => import('./pages/eventos/listas-tickets/create/create.page').then(m => m.CreatePage)
      },
      {
        path: 'eventos/:id/listas-tickets/:listaticketid',
        canActivate: [eventoGestionGuard],
        loadComponent: () => import('./pages/eventos/listas-tickets/show/show.page').then(m => m.ShowPage)
      },
      {
        path: 'eventos/:id/tickets',
        loadComponent: () => import('./pages/eventos/tickets/tickets.page').then(m => m.TicketsPage)
      },
      {
        path: 'eventos/:id/ventas',
        canActivate: [eventoVentasGuard],
        loadComponent: () => import('./pages/eventos/ventas/ventas.page').then(m => m.VentasPage)
      },
      {
        path: 'eventos/:id/facturas/:facturaid',
        loadComponent: () => import('./pages/eventos/facturas/detalle/factura-detalle.page').then(m => m.FacturaDetallePage)
      },
      {
        path: 'eventos/:id/facturas/:facturaid/reasignar-ticket/:ticketid',
        loadComponent: () => import('./pages/eventos/facturas/reasignar-ticket/reasignar-ticket.page').then(m => m.ReasignarTicketPage)
      },
      {
        path: 'eventos/:id/historial-carritos',
        canActivate: [eventoHistorialCarritosGuard],
        loadComponent: () => import('./pages/eventos/historial-carritos/historial-carritos.page').then(m => m.HistorialCarritosPage)
      },
      {
        path: 'eventos/:id/reportes',
        canActivate: [eventoReportesGuard],
        loadComponent: () => import('./pages/eventos/reportes/reportes.page').then(m => m.ReportesPage)
      },
      {
        path: 'eventos/:id/reportes/ventas',
        canActivate: [eventoReportesGuard],
        loadComponent: () => import('./pages/eventos/reportes/reporte-ventas/reporte-ventas.page').then(m => m.ReporteVentasPage)
      },
      {
        path: 'eventos/:id/reportes/pagos',
        canActivate: [eventoReportesGuard],
        loadComponent: () => import('./pages/eventos/reportes/reporte-pagos/reporte-pagos.page').then(m => m.ReportePagosPage)
      },
      {
        path: 'eventos/:id/reportes/tickets',
        canActivate: [eventoReportesGuard],
        loadComponent: () => import('./pages/eventos/reportes/reporte-tickets/reporte-tickets.page').then(m => m.ReporteTicketsPage)
      },
      {
        path: 'eventos/:id/reportes/estadisticas-tipoticket',
        canActivate: [eventoReportesGuard],
        loadComponent: () => import('./pages/eventos/reportes/reporte-estadisticas-tipoticket/reporte-estadisticas-tipoticket.page').then(m => m.ReporteEstadisticasTipoticketPage)
      },
      {
        path: 'eventos/:id/reportes/conciliacion',
        canActivate: [eventoReportesGuard],
        loadComponent: () => import('./pages/eventos/reportes/reporte-conciliacion/reporte-conciliacion.page').then(m => m.ReporteConciliacionPage)
      },
      {
        path: 'eventos/:id/reportes/estadisticas-tipoticket',
        canActivate: [eventoReportesGuard],
        loadComponent: () => import('./pages/eventos/reportes/reporte-estadisticas-tipoticket/reporte-estadisticas-tipoticket.page').then(m => m.ReporteEstadisticasTipoticketPage)
      },
      {
        path: 'eventos/:id/reportes/tickets-validados',
        canActivate: [eventoReportesGuard],
        loadComponent: () => import('./pages/eventos/reportes/reporte-tickets-validados/reporte-tickets-validados.page').then(m => m.ReporteTicketsValidadosPage)
      },
      {
        path: 'eventos/:id/validadores',
        canActivate: [eventoGestionGuard],
        loadComponent: () => import('./pages/eventos/validadores/validadores.page').then(m => m.ValidadoresPage)
      },
      {
        path: 'eventos/:id/ubicaciones',
        canActivate: [eventoGestionGuard],
        loadComponent: () => import('./pages/eventos/ubicaciones/index/index.page').then(m => m.UbicacionesIndexPage)
      },
      {
        path: 'eventos/:id/rubros',
        canActivate: [eventoGestionGuard],
        loadComponent: () => import('./pages/eventos/rubros/index/index.page').then(m => m.RubrosIndexPage)
      },
      {
        path: 'eventos/:id/subeventos',
        canActivate: [eventoGestionGuard],
        loadComponent: () => import('./pages/eventos/subeventos/index/index.page').then(m => m.SubeventosIndexPage)
      },
      {
        path: 'eventos/:id/subeventos/:subeventoid/edit',
        canActivate: [eventoGestionGuard],
        loadComponent: () => import('./pages/eventos/subeventos/edit/edit.page').then(m => m.SubeventosEditPage)
      },
      {
        path: 'eventos/:id/funciones',
        canActivate: [eventoFuncionesGuard],
        loadComponent: () => import('./pages/eventos/funciones/index/index.page').then(m => m.FuncionesIndexPage)
      },
      {
        path: 'eventos/:id/funciones/:fecha',
        canActivate: [eventoFuncionesGuard],
        loadComponent: () => import('./pages/eventos/funciones/detalle/detalle.page').then(m => m.FuncionesDetallePage)
      },
      {
        path: 'admin/config',
        loadComponent: () => import('./pages/admin/config/index/index.page').then(m => m.IndexPage)
      },
      {
        path: 'admin/config/edit/:type',
        loadComponent: () => import('./pages/admin/config/edit/edit.page').then(m => m.EditPage)
      },
      {
        path: 'admin/email-templates',
        loadComponent: () => import('./pages/admin/email-templates/index/index.page').then(m => m.EmailTemplatesIndexPage)
      },
      {
        path: 'admin/email-templates/edit/:sk',
        loadComponent: () => import('./pages/admin/email-templates/edit/edit.page').then(m => m.EmailTemplateEditPage)
      },
      {
        path: 'admin/ticket-templates',
        loadComponent: () => import('./pages/admin/ticket-templates/index/index.page').then(m => m.TicketTemplatesIndexPage)
      },
      {
        path: 'admin/ticket-templates/create',
        loadComponent: () => import('./pages/admin/ticket-templates/edit/edit.page').then(m => m.TicketTemplateEditPage)
      },
      {
        path: 'admin/ticket-templates/edit/:id',
        loadComponent: () => import('./pages/admin/ticket-templates/edit/edit.page').then(m => m.TicketTemplateEditPage)
      },
      {
        path: 'admin/facturadores',
        loadComponent: () => import('./pages/admin/facturadores/index/index.page').then(m => m.IndexPage)
      },
      {
        path: 'admin/facturadores/create',
        loadComponent: () => import('./pages/admin/facturadores/edit/edit.page').then(m => m.EditPage)
      },
      {
        path: 'admin/facturadores/edit/:id',
        loadComponent: () => import('./pages/admin/facturadores/edit/edit.page').then(m => m.EditPage)
      },
      {
        path: 'admin/users',
        loadComponent: () => import('./pages/admin/users/index/index.page').then(m => m.UsersIndexPage)
      },
      {
        path: 'admin/clientes',
        loadComponent: () => import('./pages/admin/users/index/index.page').then(m => m.UsersIndexPage)
      },
      {
        path: 'admin/users/create',
        loadComponent: () => import('./pages/admin/users/edit/edit.page').then(m => m.UserEditPage)
      },
      {
        path: 'admin/users/edit/:id',
        loadComponent: () => import('./pages/admin/users/edit/edit.page').then(m => m.UserEditPage)
      },
      {
        path: 'admin/clientes/create',
        loadComponent: () => import('./pages/admin/users/edit/edit.page').then(m => m.UserEditPage)
      },
      {
        path: 'admin/clientes/edit/:id',
        loadComponent: () => import('./pages/admin/users/edit/edit.page').then(m => m.UserEditPage)
      },
      {
        path: 'admin/seatmaps',
        loadComponent: () => import('./pages/admin/seatmaps/index/index.page').then(m => m.SeatmapsIndexPage)
      },
      {
        path: 'admin/seatmaps/create',
        loadComponent: () => import('./pages/admin/seatmaps/edit/edit.page').then(m => m.SeatmapEditPage)
      },
      {
        path: 'admin/seatmaps/edit/:id',
        loadComponent: () => import('./pages/admin/seatmaps/edit/edit.page').then(m => m.SeatmapEditPage)
      },
      {
        path: 'admin/template-forms',
        loadComponent: () => import('./pages/admin/template-forms/index/index.page').then(m => m.TemplateFormsIndexPage)
      },
      {
        path: 'admin/template-forms/create',
        loadComponent: () => import('./pages/admin/template-forms/edit/edit.page').then(m => m.TemplateFormsEditPage)
      },
      {
        path: 'admin/template-forms/edit/:id',
        loadComponent: () => import('./pages/admin/template-forms/edit/edit.page').then(m => m.TemplateFormsEditPage)
      }
          ,
          {
            path: 'admin/categorias-eventos',
            loadComponent: () => import('./pages/admin/categorias-eventos/index/index.page').then(m => m.CategoriasEventosIndexPage)
          },
          {
            path: 'admin/categorias-eventos/create',
            loadComponent: () => import('./pages/admin/categorias-eventos/edit/edit.page').then(m => m.CategoriasEventosEditPage)
          },
          {
            path: 'admin/categorias-eventos/edit/:id',
            loadComponent: () => import('./pages/admin/categorias-eventos/edit/edit.page').then(m => m.CategoriasEventosEditPage)
          }
    ]
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/auth/login/login.page').then(m => m.LoginPage)
  },
  {
    path: 'eventos/:id/facturas/:facturaid/comprobante-sri',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/eventos/facturas/comprobante-sri/comprobante-sri.page').then(m => m.ComprobanteSriPage)
  },
  {
    path: 'eventos/:eventoid/funciones/asistentes/:tipoticketid',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/eventos/funciones/asistentes-preview/asistentes-preview.page').then(m => m.AsistentesPreviewPage)
  },
  {
    path: 'index',
    loadComponent: () => import('./pages/eventos/tipos-ticket/index/index.page').then( m => m.IndexPage)
  }
];

